











 














const node = {
  "kind": "InlineDataFragment",
  "name": "useSnacksForNewMeetings_meetings"
};

(node ).hash = "15bd6511fe3cbb1d04a4f7c5780dae72";

export default node;
